import { FormFieldStyles } from "@/components/FormField/FormFieldStyles.ts"

import type { PropsWithChildren, ReactNode } from "react"

export interface FormFieldProps extends PropsWithChildren {
  label?: ReactNode
  description?: ReactNode
  error?: ReactNode
  className?: string
}

export const FormField = ({ label, description, error, className, children }: FormFieldProps) => {
  return (
    <FormFieldStyles.Container className={className}>
      {label && <FormFieldStyles.Label>{label}</FormFieldStyles.Label>}
      {description && <FormFieldStyles.Description>{description}</FormFieldStyles.Description>}
      <FormFieldStyles.InputContainer>{children}</FormFieldStyles.InputContainer>
      {error && <FormFieldStyles.Error>{error}</FormFieldStyles.Error>}
    </FormFieldStyles.Container>
  )
}
